export const people=`alexander.gubin
alex.potapenko
alexander.rymarchik
alexander.trofimovich
alexandra.kuznetsova
alexey.deshkevich
alexey.klionskiy
alexey.meshkov
alexey.yaremenko
andre.muehlemann
andrey.kalashnikov
anton.fomin
anton.proshkuratov
artur.zyzanski
bartlomiej.kurzeja
cristian.chilba
daria.majka
denis.tamkovich
dmitry.gulyakevich
dmitry.stasilevich
dzmitry.lukashuk
eldiiar.egemberdiev
elena.mavricheva
farruh.sheripov
gregor.hirner
hanna.liudchyk
igor.tregub
jakub.michalski
kiril.shopik
konstantin.bogdashkin
konstantin.nesterov
maksim.sidorenko
mariya.lavnik
natalia.ignatovich
nikolay.kuznetsov
nina.viter
oleg.stepura
olga.hatskevich
sabrina.soelch
sergey.pleshkov
silvan.muehlemann
tomasz.bielecki
tomasz.wasikowski
viktor.sobor
vsevolod.vikhrov`
